<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">销售工具</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">短信</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="callcenter">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="通话记录">
                    <div class="top-search record-search">
                        <a-row type="flex">
                            <a-col><label for="">通话时间：</label></a-col>
                            <a-col>
                                <div class="select-date-custom">
                                    <a-input class="search-date" v-model="time" @click="showdate">
                                        <a-tooltip slot="suffix" @click="showdate">
                                            <div class="date-icon"></div>
                                        </a-tooltip>
                                    </a-input>
                                    <span class="select-date-modal" v-if="dateshow">
                                        <div class="date-modal">
                                            <div class="time-modal">
                                                <div class="time-system">
                                                    <div class="select-item" @click="selectdate(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                                </div>
                                                <div class="time-custom">
                                                    <span class="time-system-text">自定义</span>
                                                    <div class="time-select-index-hide">
                                                        <a-range-picker format="YYYY-MM-DD" @change="dateChange"/>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                
                            </a-col>
                        </a-row>

                        <a-row  type="flex">
                            <a-col><label for="">部门/员工：</label></a-col>
                            <a-col>
                                <a-select mode="multiple" style="width: 120px" @change="yghandleChange">
                                    <a-select-option v-for="item in userlist" :key="item.id" value="item.id">{{item.name}}</a-select-option>
                                </a-select>
                            </a-col>
                        </a-row>

                        <a-row  type="flex">
                            <a-col><label for="">通话类型：</label></a-col>
                            <a-col>
                                <a-select style="width: 120px" @change="lxhandleChange">
                                    <a-select-option value="线索">
                                        线索
                                    </a-select-option>
                                    <a-select-option value="客户">
                                        客户
                                    </a-select-option>
                                    <a-select-option value="商机">
                                        商机
                                    </a-select-option>
                                    <a-select-option value="直呼">
                                        直呼
                                    </a-select-option>
                                    <a-select-option value="回呼">
                                        回呼
                                    </a-select-option>
                                </a-select>
                            </a-col>
                        </a-row>

                        <a-row  type="flex">
                            <a-col><label for="">通话时长：</label></a-col>
                            <a-col>
                                <a-input style="width:80px" v-model="star" ></a-input> ~ <a-input v-model="end" style="width:80px"></a-input>
                            </a-col>
                        </a-row>

                        <a-row  type="flex">
                            <a-col><label for="">通话方式：</label></a-col>
                            <a-col>
                                <a-select style="width: 120px" @change="fshandleChange">
                                    <a-select-option v-for="(item,i) in calllist" :key="i" :value="i">
                                        {{item}}
                                    </a-select-option>
                                </a-select>
                            </a-col>
                        </a-row>

               
                    </div>

                    <div class="table-content">
                        <div class="table-top-info" style="margin-top:0;display:flex;justify-content: space-between">
                            <div style="display: flex;align-items: center;">
                                <!-- <a-button @click="exportmodal" :size="btnsize" icon="upload" type="primary">导出报表</a-button> -->
                                <!-- <a-button :size="btnsize" icon="upload">导出录音</a-button> -->
                                <div>接听率: {{statistic.percent}}</div>
                                <div>通话次数: {{pagination.total}}</div>
                                <div>接听次数: {{statistic.hascall}}</div>
                                <div>累计通话时长:{{statistic.totalbillsec}}</div>
                                <div>平均通话时长:{{statistic.average}}</div>
                            </div>
                            

                            <div>
                                <a-input-search
                                placeholder="请输入联系号码"
                                enter-button="搜索"
                                @search="onSearch"
                                />
                            </div>
                        </div>

                        <a-spin :spinning="tablespinning">
                            <a-table :pagination="pageshow" :scroll="{ y: tabley}" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :style="{height:tabley+'px'}" rowKey="id" :columns="columns" :data-source="data">
                                <a slot="name" slot-scope="text">{{ text }}</a>
                                <span slot="status" slot-scope="text">
                                    <span class="telsuccess" v-if="text==0">未接听</span>
                                    <span class="telfail" v-else>已接听</span>
                                </span>

                                <span class="call-record" slot="action" slot-scope="text, record" v-if="record.billsec!=0">
                                    <a-popover class="call-record-video" placement="bottomRight" trigger="click">
                                        <template slot="content">
                                            <audio :id="record.id" :src="record.oss_url">
                                                你的浏览器不支持audio标签
                                            </audio>
                                            <div class="showStatusBox">
                                                <div class="playStatusIcon" >
                                                    <a-icon v-if="play" @click="playAudio(record.id)" type="caret-right" />
                                                    <a-icon v-if="pause" @click="pauseAudio(record.id)" type="pause" />
                                                </div>
                                                <div class="video-currentTime">{{audioCurrentTime}}</div>
                                                <div class="video-sliderBox">
                                                    <a-slider id="test" v-model="audioTime" :disabled="disabled" />
                                                </div>
                                                <div class="totalTime">{{record.billsecformate}}</div>
                                            </div>
                                            <div class="video-toolsBox">
                                                <div class="ChangeRateBox">
                                                    <a href="javascript:;">倍速</a>
                                                    <a-select default-value="1" :showArrow="arrow" style="width: 120px" @change="changeSpeed($event,record.id)">
                                                        <a-select-option value="1">
                                                            1.0X
                                                        </a-select-option>
                                                        <a-select-option value="1.5">
                                                            1.5X
                                                        </a-select-option>
                                                        <a-select-option value="2">
                                                            2.0X
                                                        </a-select-option>
                                                    </a-select>
                                                </div>

                                                <div class="video-download">
                                                    <a-icon type="download" />
                                                </div>

                                                <div class="video-readtext">
                                                    <span @click="totext($event,record.oss_url,record.billsecformate)" :id="record.id">查看文本</span>
                                                </div>
                                            </div>
                                        </template>
                                        <img src="../../../static/svg/play.svg" alt="">录音
                                    </a-popover>
                                </span>
                                <span v-else>--</span>
                            </a-table>

                            <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                                <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                                <a-pagination
                                show-size-changer
                                :page-size-options="pageSizeOptions"
                                :default-current="1"
                                :total="pagination.total"
                                :defaultPageSize="10"
                                @change="handleTableChange"
                                @showSizeChange="onShowSizeChange"
                                >
                                    <template slot="buildOptionText" slot-scope="props">
                                        <span>{{ props.value }}条/页</span>
                                    </template>

                                </a-pagination>
                            </div>
                        </a-spin>
                    </div>

                </a-tab-pane>
                <a-tab-pane key="2" tab="呼叫统计" force-render>
                    <a-tabs default-active-key="1" class="tel-tj-tab">
                        <a-tab-pane key="1" tab="按日期">
                            <div class="top-search record-search" style="">
                                <a-row type="flex">
                                    <a-col><label for="">通话时间：</label></a-col>
                                    <a-col>
                                        <div class="select-date-custom">
                                            <a-input class="search-date" v-model="time" @click="showdate">
                                                <a-tooltip slot="suffix" title="Extra information">
                                                    <div class="date-icon"></div>
                                                </a-tooltip>
                                            </a-input>
                                            <span class="select-date-modal" v-if="dateshow">
                                                <div class="date-modal">
                                                    <div class="time-modal">
                                                        <div class="time-system">
                                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                                        </div>
                                                        <div class="time-custom">
                                                            <span class="time-system-text">自定义</span>
                                                            <div class="time-select-index-hide">
                                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                        
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">部门/员工：</label></a-col>
                                    <a-col>
                                        <a-select mode="multiple" style="width: 120px" @change="yghandleChange2">
                                            <a-select-option v-for="item in userlist" :key="item.id" value="item.id">{{item.name}}</a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">通话类型：</label></a-col>
                                    <a-col>
                                        <a-select style="width: 120px" @change="lxhandleChange2">
                                            <a-select-option value="线索">
                                                线索
                                            </a-select-option>
                                            <a-select-option value="客户">
                                                客户
                                            </a-select-option>
                                            <a-select-option value="商机">
                                                商机
                                            </a-select-option>
                                            <a-select-option value="直呼">
                                                直呼
                                            </a-select-option>
                                            <a-select-option value="回呼">
                                                回呼
                                            </a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">通话时长：</label></a-col>
                                    <a-col>
                                        <a-input style="width:80px" v-model="hjstar" ></a-input> ~ <a-input v-model="hjend" style="width:80px"></a-input>
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">通话方式：</label></a-col>
                                    <a-col>
                                        <a-select style="width: 120px" @change="fshandleChange2">
                                         
                                            <a-select-option v-for="(item,i) in calllist" :key="i" :value="i">
                                                {{item}}
                                            </a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>

                
                            </div>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="2" tab="按员工" force-render>
                            Content of Tab Pane 2
                        </a-tab-pane> -->
                    </a-tabs>

                    <div class="tj-charts" style="margin-left:10px;mragin-right:10px;background:#fff;z-index:998">
                        <a-tabs default-active-key="1" @change="switchcharts">
                            <a-tab-pane key="1" tab="接听率"></a-tab-pane>
                            <a-tab-pane key="2" tab="呼出次数"></a-tab-pane>
                            <a-tab-pane key="3" tab="通话人数"></a-tab-pane>
                            <a-tab-pane key="4" tab="通话时长"></a-tab-pane>
                            <a-tab-pane key="5" tab="平均通话时长"></a-tab-pane>
                        </a-tabs>

                        <div class="chart-content" >
                            <div id="weightChart" style="width: 100%;height:394px;"></div>
                        </div>
                    </div>

                    <div class="table-content">
                        <div class="table-top-info" style="margin-top:0">
                            <a-button @click="exportmodal" :size="btnsize" icon="upload">导出</a-button>
                            <div>接听率: {{statistic2.percent}}</div>
                            <div>通话次数: {{statistic2.noanswer+statistic2.hascall}}</div>
                            <div>接听次数: {{statistic2.hascall}}</div>
                            <div>累计通话时长:{{statistic2.totalbillsec}}</div>
                            <div>平均通话时长:{{statistic2.average}}</div>
                        </div>
                        <a-spin :spinning="tablespinning">
                            <a-table :pagination="pageshow" :scroll="{ y: tabley}"  :style="{height:tabley+'px'}" :columns="columns2" :data-source="data2">
                            </a-table>
                        </a-spin>
                    </div>


                </a-tab-pane>
                <!-- <a-tab-pane key="3" tab="实时监控">
                    Content of Tab Pane 3
                </a-tab-pane> -->
            </a-tabs>
        </div>

        <!-- 导出数据 -->
        <a-modal
            title="批量导出"
            :visible="exportvisible"
            :confirm-loading="confirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            :footer="null"
            >
            <div class="import-text">
                <a-spin :spinning="spinning">
                    <div class="export-content" >
                        <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 54px; height: 54px; margin-bottom: 12px;">
                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard-Copy-83"><circle id="Oval-12" fill="#33B028" cx="27" cy="27" r="27"></circle><polyline id="Path-9" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 28.6835304 22.5324773 37 41 19"></polyline></g></g>
                        </svg> 
                        <h4>批量导出已完成</h4>
                        <p>线索导出已完成,导出数据量3条，下载导出文件。</p>
                        <a class="export-btn" :href="exporturl" download>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon-color-2"><rect id="矩形" x="0" y="0" width="20" height="20"></rect><circle id="椭圆形" fill="#4F7AFD" cx="10" cy="10" r="7"></circle><path d="M13.7874223,8.70748256 L10.6082602,6.24464133 C10.4561396,6.09636616 10.2413392,6 9.99995555,6 C9.75857185,6 9.54386039,6.09636616 9.39422917,6.24616557 L6.20991046,8.70570428 C6.08170594,8.83831359 6,9.0096218 6,9.19955966 C6,9.60729521 6.36647646,9.93788702 6.81821516,9.93788702 C6.82452759,9.93788702 6.8306622,9.93712489 6.83688572,9.93695553 L6.83688572,9.94161295 L8.66634397,9.94161295 L8.66634397,14 L11.3335671,14 L11.3335671,9.94161295 L13.1331525,9.94161295 L13.1331525,9.93568533 C13.1493336,9.93653213 13.1652481,9.93805638 13.1817848,9.93805638 C13.6336124,9.93805638 14,9.60737989 14,9.19955966 C14,9.0096218 13.9182052,8.83839827 13.7874223,8.70748256 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "></path><rect id="矩形" fill="#4F7AFD" x="8" y="7" width="4" height="1"></rect></g></g>
                            </svg>
                            <span>下载导出文件</span>
                        </a>
                    </div>
                </a-spin>
            </div>
        </a-modal>


        <!-- 录音文本 -->
        <a-modal
        title="通话记录"
        :visible="textvisible"
        :confirm-loading="confirmLoading"
        @cancel="handleCancel"
        :footer="null"
        width="373px"
        >
            <div class="recording-audio">
                <p v-html="lxtext"></p>
                <!-- v-hte {{lxtext}} -->
            </div>
            <audio :id="lxid" :src="lxurl">
                你的浏览器不支持audio标签
            </audio>
            <div class="showStatusBox">
                <div class="playStatusIcon" >
                    <a-icon v-if="play" @click="playAudio(lxid)" type="caret-right" />
                    <a-icon v-if="pause" @click="pauseAudio(lxid)" type="pause" />
                </div>
                <div class="video-currentTime">{{audioCurrentTime}}</div>
                <div class="video-sliderBox">
                    <a-slider id="test" v-model="audioTime" :disabled="disabled" />
                </div>
                <div class="totalTime">{{lxtime}}</div>
            </div>
        </a-modal>
    </div>
</template>
<style>
    .ant-tabs-top-content{margin-top:0 !important;}
</style>
<script>
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};
const columns = [
    {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width:"80px"
  },
  {
    title: '通话类型',
    dataIndex: 'calltype',
    key: 'calltype',
  },
  {
    title: '员工',
    dataIndex: 'user_name',
    key: 'user_name',
    width: 80,
  },
  {
    title: '关联客户',
    dataIndex: 'kehu_id',
    key: 'kehu_id',
    ellipsis: true,
  },
  {
    title: '联系号码',
    dataIndex: 'phone',
    key: 'phone',
    ellipsis: true,
  },
  {
    title: '通话方式',
    dataIndex: 'calltype',
    key: 'calltype',
    ellipsis: true,
  },
  {
    title: '通话时间',
    dataIndex: 'add_time',
    key: 'add_time',
    ellipsis: true,
    width:'160px'
  },
  {
    title: '通话状态',
    dataIndex: 'billsec',
    key: 'billsec',
    scopedSlots: { customRender: 'status' },
    ellipsis: true,
  },
  {
    title: '通话时长',
    dataIndex: 'billsec',
    key: 'billsec',
    ellipsis: true,
  },
   {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width:'164px'
  },
];

const columns2 = [
  {
    title: '联系时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '通话人数',
    dataIndex: 'callpeople',
    key: 'callpeople',
    width: 80,
  },
  {
    title: '通话时长',
    dataIndex: 'callbillsec',
    key: 'callbillsec',
    ellipsis: true,
  },
  {
    title: '呼出次数',
    dataIndex: 'callnum',
    key: 'callnum',
    ellipsis: true,
  },
  {
    title: '接听次数',
    dataIndex: 'holdnum',
    key: 'holdnum',
    ellipsis: true,
  },
  {
    title: '接听率',
    dataIndex: 'callpercent',
    key: 'callpercent',
    ellipsis: true,
  },
  {
    title: '平均通话时长',
    dataIndex: 'avg',
    key: 'avg',
    ellipsis: true,
  }
];

let audioInterval;
export default {
    data(){
        return{
            columns,
            columns2,
            data:[],
            btnsize:'',
            rowSelection,
            pagination:{},
            size:10,
            currentpage:"",
            pageshow:false,
            totalpage:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            tabley:"",
            tablespinning:true,
            selectedRowKeys:[],
            statistic:"",
            arrow:false,

            // audioDetail: testJson.data,//音频详情
            audioTime:0,//音频进度百分比
            audioCurrentTime:'00:00',//音频当前播放时间
            audioAllTime:'00:00',//音频总播放时间
            audioAllDuration:0,//音频总播放秒数
            isPlay:false,//是否正在播放
            multipleArray:[0.75,1,1.5,2],
            multipleIndex:1,

            play:true,
            pause:false,
            value:"",

            exportvisible:false,
            confirmLoading:false,
            spinning:true,

            textvisible:false,
            lxurl:"",
            lxid:"",
            lxtime:"",
            exporturl:"",
            lxtext:"",

            type:"",
            time:"",
            callrang:"",
            belong:[],
            method:"",
            datelist:['今天','昨天','本周','上周','本月','上月'],
            datelist2:['今天','昨天'],
            currentdate:"",
            calllist:"",
            star:"",
            end:"",
            dateshow:false,
            userlist:"",


            data2:[],
            xstr:[],
            ystr:[],
            callpercentstr:{},
            callnum:[],
            callpeoplestr:[],
            callbillsecstr:[],
            avgstr:[],

            // videovisible:false

            hjstar:"",
            hjend:"",
            hjtype:"",
            hjtime:"",
            hjcallrang:"",
            hjbelong:[],
            hjmethod:"",

            statistic2:""

        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){

        this.fetch()
        this.hjtj()
        this.hjtb()
       

        // 员工
        this.$axios.get('/api/userlist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.userlist=res.data.data.lists
            }
        })

        // 通话方式
        this.$axios.get('/api/getcalltype',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.calllist=res.data.data
                // alert("calllist="+this.calllist)
            }
        })

        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };

     
        // this.setAudioInterval();
    },
    methods:{
        hjtj(){
            // 呼叫统计
            var lang=this.hjstar+'~'+this.hjend
            this.$axios.post('/api/callstatictis',{
                    type:this.hjtype,
                    method:this.hjmethod,
                    callrang:lang,
                    time:this.hjtime,
                    belong:this.hjbelong
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.data2=[]
                    for(var i in res.data.data.list){
                        this.data2.push(res.data.data.list[i])
                        this.statistic2=res.data.data.statistic
                    }
                    
                }
            })
        },

        hjtb(){
             // 图表
            var lang=this.hjstar+'~'+this.hjend
            this.$axios.post('/api/callstatictis',{
                    type:this.hjtype,
                    method:this.hjmethod,
                    callrang:lang,
                    time:this.hjtime,
                    belong:this.hjbelong
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.xstr=res.data.data.echart.xstr
                    this.callpercentstr=res.data.data.echart.callpercentstr
                    this.callnum=res.data.data.echart.callnum
                    this.callpeoplestr=res.data.data.echart.callpeoplestr
                    this.callbillsecstr=res.data.data.echart.callbillsecstr
                    this.avgstr=res.data.data.echart.avgstr
                    this.ystr=res.data.data.echart.callpercentstr
                    this.drawLine()
                }
            })

        },
        

         /** 设置倍速播放 */
        changeSpeed(event,value) {
            // alert(value)
          let audioPlayer = document.getElementById(value);;
          audioPlayer.playbackRate = event;
        //   this.speed = command;
        },

        switchcharts(key){
            if(key==1){
                this.ystr=this.callpercentstr
                this.hjtb()
                this.drawLine()
            }else if(key==2){
                this.ystr=this.callnum
                this.hjtb()
                this.drawLine()
            }else if(key==3){
                this.ystr=this.callpeoplestr
                this.hjtb()
                this.drawLine()
            }else if(key==4){
                this.ystr=this.callbillsecstr
                this.hjtb()
                this.drawLine()
            }else if(key==5){
                this.ystr=this.avgstr
                this.hjtb()
                this.drawLine()
            }
        },
        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                xAxis: {
                    type: 'category',
                    data: this.xstr,
                    boundaryGap: false,
                },
                yAxis: {
                    name: '呼出/接听次数',
                    type: 'value'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#fff',
                            color: '#333'
                        },
                    }
                },
                grid: {  
                    left: '2%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '14%',  
                    containLabel: true  
                },  
                series: [{
                    data: this.ystr,
                    type: 'line',
                    smooth: true,
                    itemStyle: {
                        normal: {
                            color: '#bd48f9', //改变折线点的颜色
                            lineStyle: {
                                color: '#bd48f9' //改变折线颜色
                            }
                        }
                    },

                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset:0,
                                    color:'#e8c5fa'
                                },
                                {
                                    offset:1,
                                    color:'#fff'
                                }
                            ])
                        }
                    },
     
                }]
            });
        },

        yghandleChange(){

        },
        showdate(){
            this.dateshow=!this.dateshow
        },


        dateChange2(data,dateString){
            console.log(dateString)
            this.hjtime=dateString
            this.dateshow=false
            this.hjtj()
        

        },
        lxhandleChange2(value){
            this.hjtype=value
            this.hjtj()
        },
        selectdate2(a,b){
            this.currentdate=a
            this.hjtime=b
            this.dateshow=false
            this.hjtj()
        },
        fshandleChange2(value){
            this.hjmethod=value
            this.hjtj()    
        },

        dateChange(data,dateString){
            console.log(dateString)
            this.time=dateString[0]+'~'+dateString[1]
            this.dateshow=false
            this.fetch()
        },
        lxhandleChange(value){
            this.type=value
            this.fetch()
        },
        selectdate(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.fetch()
        },
        fshandleChange(value){
            this.method=value
            this.fetch()    
        },



        // 转文本
        totext(event,value,c){
            var id=event.currentTarget.id
            this.lxurl=value
            this.lxtime=c
            this.$axios.get("/api/toluyintext",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.textvisible=true
                    this.lxtext=res.data.data.luyintxt
                   
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 导出报表
        handleCancel(){
            this.exportvisible=false
            this.textvisible=false
        },
        exportmodal(){
            this.exportvisible=true
            this.$axios.get("/api/exportcall",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.exporturl=res.data.data.downloadurl
                }
            })
        },


        //设置定时检测
        setAudioInterval(){
            var value=this.value
            audioInterval = setInterval(()=>{
                this.getAudioTime();
                let audioPlayer = document.getElementById(value);
                if(audioPlayer.ended){
                    //播放结束后重置数据
                    clearInterval(audioInterval);
                    this.audioTime=0;
                    audioPlayer.currentTime = 0;
                    this.audioCurrentTime='00:00';
                    this.isPlay=false;
                    this.play=true;
                    this.pause=false
                }
                audioPlayer.paused?this.isPlay=false:this.isPlay=true
            },500)
        },

        //  暂停
        pauseAudio(value){
            this.value=value
            document.getElementById(value).pause();
            this.isPlay=false;
            this.play=true;
            this.pause=false
        },

        playAudio(value){
            this.value=value
            //重设定时器
            clearInterval(audioInterval);
            this.getAudioTime(value);
            this.setAudioInterval();
            document.getElementById(value).play();
            this.isPlay=true;
            this.play=false;
            this.pause=true
        },

         //获取播放时间
        getAudioTime(value){
            var value=this.value
            let audioPlayer = document.getElementById(value);
            // alert(audioPlayer)
            //展示用
            // this.audioAllTime = this.realFormatSecond(audioPlayer.duration);
            // this.audioAllDuration = audioPlayer.duration;
            this.audioCurrentTime = this.realFormatSecond(audioPlayer.currentTime);
            //计算当前进度百分比
            this.audioTime = (audioPlayer.currentTime*100/audioPlayer.duration).toFixed(3);
            // console.log("百分比--"+this.audioTime)
        },

        //格式化秒
        realFormatSecond(second) {
            var secondType = typeof second
            if (secondType === 'number' || secondType === 'string') {
                second = parseInt(second)
                // var hours = Math.floor(second / 3600)
                // second = second - hours * 3600
                second = second
                var mimute = Math.floor(second / 60)
                second = second - mimute * 60
                return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
            } else {
                return '00:00'
            }
        },



        handleChange(){

        },
        onSearch(){

        },

        // 复选框选择
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            // alert(pageSize)
            this.fetch();
        },
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        fetch(params = {}) {
            var lang=this.star+'~'+this.end
            this.loading = true;
            this.$axios.post('/api/getcalllist',{
                    limits: this.size,
                    page:this.currentpage,
                    type:this.type,
                    method:this.method,
                    callrang:lang,
                    time:this.time,
                    belong:this.belong
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.statistic=res.data.data.statistic
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    pagination.pageSize=this.size
                    this.data=res.data.data.lists
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.count/this.size)
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/appalication/record.vue